import Card from "@material-ui/core/Card";
import Popover from "@material-ui/core/Popover";
import { makeStyles } from "@material-ui/core/styles";
import { ReactNode } from "react";
import { spaceBetween } from "../../../common/util/Array/spaceBetween";
import { DarkButton } from "../Button/DarkButton";

export function DarkPopoverMenu({
    anchorEl,
    containerEl,
    open,
    onClose,
    items,
    disabled,
}: {
    anchorEl: HTMLButtonElement | HTMLDivElement | SVGSVGElement | null;
    containerEl: HTMLDivElement | null;
    open: boolean;
    onClose: () => void;
    items: {
        key?: string;
        label: string;
        onClick?: () => void;
        icon?: ReactNode;
    }[];
    disabled?: boolean;
}) {
    const c = usePopoverStyles();

    return (
        <Popover
            classes={{
                paper: c.paper,
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{ vertical: "top", horizontal: "center" }}
            transformOrigin={{
                vertical: "bottom",
                horizontal: "center",
            }}
            elevation={0}
            onClick={ev => {
                ev.stopPropagation();
                onClose();
            }}
            container={containerEl}
        >
            <div className={c.container}>
                <Card className={c.card} elevation={0}>
                    {items.map((item, i) => (
                        <DarkButton
                            key={item.key || item.label}
                            startIcon={item.icon}
                            onClick={() => {
                                item.onClick?.();
                                onClose();
                            }}
                            className={spaceBetween(
                                c.darkButton,
                                i === 0 && c.topDarkButton
                            )}
                            disabled={disabled}
                        >
                            {item.label}
                        </DarkButton>
                    ))}
                </Card>
                <div className={c.tail} />
            </div>
        </Popover>
    );
}
const usePopoverStyles = makeStyles(theme => ({
    topDarkButton: {
        borderBottom: "solid 1px grey",
        borderBottomRightRadius: 0,
        borderBottomLeftRadius: 0,
    },
    darkButton: {
        paddingLeft: 20,
        paddingRight: 20,
    },
    paper: {
        backgroundColor: "rgba(0,0,0,0)",
    },
    tail: {
        position: "absolute",
        bottom: 10,
        transform: "rotate(45deg)",
        backgroundColor: theme.palette.grey[800],
        zIndex: 1,
        width: 30,
        height: 30,
    },
    card: {
        backgroundColor: theme.palette.grey[800],
        zIndex: 2,
        display: "flex",
        flexDirection: "column",
    },
    container: {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        position: "relative",
        width: "100%",
        height: "100%",
        paddingBottom: 15,
    },
}));
